<template>
  <TsCard
    noShadow
    :append-class="
      twMerge(
        'mb-5 bg-white border-[#DCEDFD] relative h-full',
        isMobile && 'p-0 border-0 rounded-none'
      )
    "
  >
    <div class="flex items-center gap-24px mb-4">
      <TsIcon
        name="akar-icons:arrow-left"
        :size="24"
        class="mr-4 cursor-pointer"
        @click="showProCardUserData"
      >
      </TsIcon>

      <TsTypography
        appendClass="font-family-Gilroy-SemiBold leading-[24px] text-[#121212]"
        weight="400"
        align="left "
      >
        {{
          useTranslation(
            "ProCard-myProCardOrders",
            "Mijn PRO-kaartbestellingen"
          )
        }}
      </TsTypography>
    </div>
    <TsDivider append-class="min-h-0" />
    <TsLoadingCircularSpinner v-if="accountStore.loading" />
    <template v-else>
      <TsTypography
        appendClass="font-family-Gilroy-SemiBold leading-[24px] size-16px text-[#6B7280] mb-2"
        align="left "
      >
        {{ useTranslation("searchOrders", "Zoek bestellingen") }}
      </TsTypography>
      <TsMedia :class="twMerge(isMobile && 'flex flex-col gap-4')">
        <TsMediaContent>
          <div class="flex items-center gap-x-3">
            <TsInput
              :placeholder="
                useTranslation(
                  'searchByInvoiceNumber',
                  'Zoek op factuurnummer, label, enz.'
                )
              "
              icon="jam:search"
              v-model="accountStore.pro_card_order_search_query"
              icon-position="left"
              :append-class="twMerge('w-80', isMobile && 'w-full')"
              input-class="w-full"
              :rounded="isMobile"
              @input="filterData()"
            />
          </div>
        </TsMediaContent>
        <TsMediaEnd class="text-right">
          <TsButton
            icon="octicon:download-16"
            :label="useTranslation('downloadInvoices', 'Facturen downloaden')"
            :disabled="accountStore.selected_pro_card_order_ids.length === 0"
            @click="accountStore.downloadOrderHistoryInvoices(label)"
            size="sm"
            disabled
          />
        </TsMediaEnd>
      </TsMedia>
      <div class="py-4">
        <TsTableView :data="proCardOrderData">
          <template #pagination>
            <TsPagination
              v-if="totalItems > offset"
              :data-length="totalItems"
              v-model="accountStore.orders_current_page"
              :active-page-number="accountStore.orders_current_page"
              :offset="offset"
              type="stepless"
              @next="handleActivePage"
              @prev="handleActivePage"
              @first="handleActivePage"
              @last="handleActivePage"
              append-class="items-center py-2 absolute bottom-0 left-1/2 -translate-x-1/2"
            />
          </template>
        </TsTableView>
      </div>
    </template>
  </TsCard>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { twMerge } from "tailwind-merge";

const TsCard = defineAsyncComponent(() => import('~/components/organisms/TsCard.vue'));
const TsLoadingCircularSpinner = defineAsyncComponent(() => import('~/components/organisms/TsLoadingCircularSpinner.vue'));
const TsMediaContent = defineAsyncComponent(() => import('~/components/organisms/TsMediaContent.vue'));
const TsMediaEnd = defineAsyncComponent(() => import('~/components/organisms/TsMediaEnd.vue'));
const TsTableView = defineAsyncComponent(() => import('~/components/organisms/TsTableView.vue'));
const TsPagination = defineAsyncComponent(() => import('~/components/molecules/TsPagination.vue'));

const offset = 10;
const proCardOrderData = ref([]);
const { isMobile } = useDevice();
const authStore = useAuthStore();
const accountStore = useAccountStore();

const showProCardUserData = () => navigateTo("/account/pro-card");

const totalItems = computed(() => accountStore.pro_card_orders_data.length);

onMounted(async () => {
  if (authStore.user?.id) {
    await accountStore.fetchProCardOrdersHistory(authStore.user?.id);
    accountStore.pro_card_orders_data = accountStore.pro_card_orders_data.map(
      (item) => ({
        ...item,
        label: "",
        isModified: false,
      })
    );
  }
});

function paginatedData(products) {
  const page = accountStore.orders_current_page;
//   console.log(
//     products.slice((page - 1) * offset, (page - 1) * offset + offset),
//     products,
//     page,
//     "+++"
//   );
  return products.length > 10
    ? products.slice((page - 1) * offset, (page - 1) * offset + offset)
    : products;
}

watch(accountStore, () => {
  proCardOrderData.value = paginatedData(accountStore.pro_card_orders_data);
});

definePageMeta({
  layout: "account",
});

function filterData() {
  const query = accountStore.pro_card_order_search_query;
  const filteredData = accountStore.pro_card_orders_data.filter((item) =>
    item.id.toString().includes(query)
  );
  proCardOrderData.value = paginatedData(filteredData);
}

const handleActivePage = (page) => {
  scrollToTop();
  accountStore.orders_current_page = page;
  accountStore.selected_pro_card_order_ids = [];
  accountStore.all_pro_card_orders_selected = false;
};
</script>
